import axios from "axios";
import store from "@/store";
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { removeAPIPrefix } from "../../utils/url";

let quizServiceInstance = null
const subdomain = window.location.host.split('.')[0]
const addressAPIWithoutPrefix = removeAPIPrefix(process?.env?.VUE_APP_ARANDU_QUIZ_URL)
const baseURL = process?.env?.VUE_APP_APPLICATION_SECURITY + subdomain + '.' + process?.env?.VUE_APP_ARANDU_QUIZ_URL
const reverbBaseURL = process?.env?.VUE_APP_APPLICATION_SECURITY + subdomain + '.' + addressAPIWithoutPrefix
const reverbSecretKey = process?.env?.VUE_APP_QUIZ_API_REVERB_KEY
const shouldInitializeReverb = Boolean(!quizServiceInstance && reverbSecretKey && subdomain && addressAPIWithoutPrefix)
const quizServiceReverb = () => quizServiceInstance

const initializeQuizServiceReverb = (userToken) => {
  if (shouldInitializeReverb && userToken) {
    const reverbWsConnection = () => {
      if (process?.env?.VUE_APP !== 'localhost') {
        return `${subdomain}.${addressAPIWithoutPrefix}`
    }
    return 'localhost'   
    }

    try {
      quizServiceInstance = new Echo({
        broadcaster: 'reverb',
          key: reverbSecretKey,
          wsHost: reverbWsConnection(),
          wsPort: process?.env?.VUE_APP === 'localhost' ? 6003: 80,
          wssPort: process?.env?.VUE_APP === 'localhost' ? 6003 : 443,
          forceTLS: window.location.protocol === 'https',
          path: process?.env?.VUE_APP === 'localhost' ? '/app' : '/quiz-app',
          enabledTransports: ['ws', 'wss'],
          authEndpoint: `${reverbBaseURL}/broadcasting/auth`,
          auth: {
              headers: {
                  Authorization: 'Bearer ' + userToken,
              },
          }
      })
    } catch (error) {
      console.error(error)
    }
  }
}

const leaveQuizServiceReverbPrivateChannel = (channelName) => {
  if (quizServiceInstance && channelName) {
    quizServiceInstance.leave(`private-${channelName}`)
  }
}

const verifyQuizServiceReverb = (consumerId) => {
  if (quizServiceInstance) {
    let connectedInChannel = false
    try {
      quizServiceReverb().private(`App.Models.User.${consumerId}`)
      connectedInChannel = true
    } catch (error) {
      console.error("Quiz WS: ", error)
    } finally {
      if (connectedInChannel) {
      setTimeout(() => {
        quizServiceReverb().leave(`App.Models.User.${consumerId}`)
      }, 10000)
      }
    }
  }
}

const QuizApiService = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-type": "application/json",
    Accept: "application/json",
  },
});

QuizApiService.interceptors.request.use(
  (config) => {
    const token = store.state.login.authToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  
  (error) => {
    return Promise.reject(error);
  }
);

export {
  quizServiceReverb,
  leaveQuizServiceReverbPrivateChannel,
  initializeQuizServiceReverb,
  verifyQuizServiceReverb
}

export default QuizApiService;